import { htmlToText } from "lib/html-to-text"

export function assessStatus(payload, target) {
    payload.status = { summary: "", reasons: [] }
    const { reasons } = payload.status
    if (payload.pictures?.documents?.length) {
        payload.status.summary = "cyan"
        reasons.push("Added pictures")
    }
    if (
        htmlToText(payload.introduction).length ||
        htmlToText(payload.notes).length ||
        Object.values(payload.tasks).some((t) => htmlToText(t.introduction).length || htmlToText(t.notes).length)
    ) {
        payload.status.summary = "cyan"
        reasons.push("Added text/notes")
    }
    // Content overrides REPLACE the master title/introduction/task text. They must register as a
    // tailoring reason so the schedule is flagged when the master library updates — otherwise a
    // content-override-only schedule would silently escape the "schedule updated" action.
    if (
        htmlToText(payload.introContentOverride).length ||
        htmlToText(payload.introNoteOverride).length ||
        Object.values(payload.tasks).some(
            (t) =>
                htmlToText(t.contentOverride).length ||
                htmlToText(t.noteOverride).length ||
                // titleOverride is plain text (single-line field), so check it directly — running it
                // through htmlToText would wrongly empty HTML-significant titles (e.g. "<x"), so a real
                // override would not flag the schedule while extend-schedule.mjs still applies it.
                (t.titleOverride ?? "").length
        )
    ) {
        payload.status.summary = "orange"
        reasons.push("Edited the introduction or task title/content/notes")
    }
    if (Object.values(payload.tasks).some((t) => t.skillSet || t.unitOfMeasure)) {
        reasons.push("Updated skillsets or unit of measurement for 1+ tasks")
        payload.status.summary = "skyblue"
    }
    if (
        target.tasks.some((t) => {
            // An absent (or empty/null) minutes override means "inherit from the schedule" — only a
            // real value the user typed counts as a duration change. A strict !== here would flag
            // every untailored task once payloads stop auto-copying the schedule minutes.
            const minutes = payload.tasks?.[t.id]?.minutes
            return minutes != null && minutes !== "" && minutes !== t.minutes
        })
    ) {
        reasons.push("Updated the duration of 1+ tasks")
        payload.status.summary = "skyblue"
    }
    if (
        target.tasks.some((t) => {
            const task = payload.tasks?.[t.id]
            return (
                task?.frequency &&
                t?.frequency &&
                (task.frequency?.period !== t.frequency?.period || task.frequency?.interval !== t.frequency?.interval)
            )
        })
    ) {
        payload.status.summary = "orange"
        reasons.push("Updated the frequency of 1+ tasks")
    }
    if (
        target.tasks.some(
            (t) =>
                t.classification !== "Red" &&
                !!payload.tasks?.[t.id]?.classification &&
                t.classification !== payload.tasks?.[t.id]?.classification
        )
    ) {
        payload.status.summary = "orange"
        reasons.push("Changed the criticality of 1+ tasks")
    }
    if (target.tasks.some((t) => payload.tasks?.[t.id]?.included === false)) {
        payload.status.summary = "orange"
        reasons.push("Removed 1+ tasks")
    }
    if (
        target.tasks.some(
            (t) =>
                t.classification === "Red" &&
                !!payload.tasks?.[t.id]?.classification &&
                t.classification !== payload.tasks?.[t.id]?.classification
        )
    ) {
        payload.status.summary = "red"
        reasons.push("Changed the criticality of 1+ Red tasks")
    }
    if (target.tasks.some((t) => t.classification === "Red" && payload.tasks?.[t.id]?.included === false)) {
        payload.status.summary = "red"
        reasons.push("Removed 1+ Red criticality tasks")
    }
    return payload.status
}
